"use strict";

// ── Header B: mega menu (desktop) + mobile nav ────────────────────────────────
(function () {
  // Bar search overlay
  var barSearchBtn = document.getElementById("hb-bar-search-btn");
  var barSearchClose = document.getElementById("hb-bar-search-close");
  if (barSearchBtn) {
    barSearchBtn.addEventListener("click", function () {
      document.body.classList.add("hb-search-open");
      setTimeout(function () {
        document.body.classList.add("hb-search-expanded");
        var input = document.querySelector("#hb-bar-search-wrapper input");
        if (input) input.focus();
      }, 0);
    });
  }
  if (barSearchClose) {
    barSearchClose.addEventListener("click", function () {
      document.body.classList.remove("hb-search-expanded");
      setTimeout(function () {
        document.body.classList.remove("hb-search-open");
      }, 400);
    });
  }
  document.querySelectorAll(".hb-secondary-search-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var bar = btn.closest(".mobile-menu-secondary-view").querySelector(".hb-secondary-search-bar");
      if (!bar) return;
      var open = bar.classList.toggle("open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) bar.querySelector("input").focus();
    });
  });

  // Mobile accordion
  document.querySelectorAll(".mobile-menu-normal__list > li.menu-item-has-children > a").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      a.parentElement.classList.toggle("expanded");
    });
  });

  // Mobile featured items → secondary view
  document.querySelectorAll(".mobile-featured-item").forEach(function (item) {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      var target = item.getAttribute("data-target");
      document.querySelectorAll(".mobile-menu-featured-children").forEach(function (v) {
        v.style.display = "none";
      });
      var el = document.getElementById(target);
      if (el) el.style.display = "flex";
      var sec = document.querySelector("#hb-mobile-nav .mobile-menu-secondary-view");
      if (sec) sec.classList.add("open");
    });
  });
  var backBtn = document.querySelector("#hb-mobile-nav .mobile-menu-secondary-view__back");
  if (backBtn) {
    backBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll(".mobile-menu-featured-children").forEach(function (v) {
        v.style.display = "none";
      });
      var sec = document.querySelector("#hb-mobile-nav .mobile-menu-secondary-view");
      if (sec) sec.classList.remove("open");
    });
  }
})();

// ── Internal page: scroll-reveal + sidebar TOC active state ──────────────────
(function () {
  var root = document.querySelector(".it2");
  if (!root) return;

  // Scroll-reveal
  var revealEls = root.querySelectorAll(".tr-reveal");
  if ("IntersectionObserver" in window) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          revealIO.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.14,
      rootMargin: "0px 0px -8% 0px"
    });
    revealEls.forEach(function (el) {
      revealIO.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add("is-in");
    });
  }

  // Build TOC dynamically from h2s inside .inner-content
  var innerContent = document.querySelector(".inner-content");
  var tocList = root.querySelector(".it2-toc");
  if (innerContent && tocList) {
    var headings = innerContent.querySelectorAll("h2");
    headings.forEach(function (h2) {
      var section = h2.closest("section");
      if (section && section.id) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href = "#" + section.id;
        a.textContent = h2.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      }
    });
  }

  // TOC active state
  var tocLinks = Array.prototype.slice.call(root.querySelectorAll(".it2-toc a"));
  var idMap = {};
  tocLinks.forEach(function (a) {
    var id = a.getAttribute("href").slice(1);
    var target = document.getElementById(id);
    if (target) idMap[id] = a;
  });
  var spyTargets = Object.keys(idMap).map(function (id) {
    return document.getElementById(id);
  });
  if ("IntersectionObserver" in window && spyTargets.length) {
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          tocLinks.forEach(function (l) {
            l.classList.remove("is-active");
          });
          var a = idMap[e.target.id];
          if (a) a.classList.add("is-active");
        }
      });
    }, {
      rootMargin: "-45% 0px -50% 0px",
      threshold: 0
    });
    spyTargets.forEach(function (t) {
      spy.observe(t);
    });
  }
})();

// ── Fade-up on scroll ─────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  var fadeElements = document.querySelectorAll(".fade-up");
  function fadeInOnScroll() {
    fadeElements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        el.classList.add("visible");
      }
    });
  }
  window.addEventListener("scroll", fadeInOnScroll);
  fadeInOnScroll();
});

// ── Floating CTA visibility ───────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  var floatingBtn = document.querySelector(".floating-cta");
  if (!floatingBtn) return;
  function toggleFloatingBtn() {
    var scrollPct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
    floatingBtn.classList.toggle("visible", scrollPct > 5);
  }
  window.addEventListener("scroll", toggleFloatingBtn);
});

// ── Swiper: generic slider containers ────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll(".slider-container .swiper");
  if (!sliders.length) return;
  sliders.forEach(function (slider, index) {
    new Swiper(slider, {
      loop: true,
      speed: 700,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: ".swiper-button-next-".concat(index),
        prevEl: ".swiper-button-prev-".concat(index)
      },
      pagination: {
        el: ".swiper-pagination-".concat(index),
        clickable: true
      },
      slidesPerView: 1,
      spaceBetween: 20
    });
  });
});